import { FundraisingDocumentType } from './enums/FundraisingDocumentType';
import { HoldingMethod } from './enums/HoldingMethod';

export const holdingMethodCertificate: Record<HoldingMethod, FundraisingDocumentType> = {
  [HoldingMethod.DIRECT]: FundraisingDocumentType.OWNERSHIP_CERTIFICATE,
  [HoldingMethod.IR_PME]: FundraisingDocumentType.IR_PME_CERTIFICATE,
  [HoldingMethod.PEA]: FundraisingDocumentType.PEA_CERTIFICATE,
  [HoldingMethod.PEA_PME]: FundraisingDocumentType.PEA_PME_CERTIFICATE,
};
